package com.vizio.redwolf.auth.model

import kotlinx.serialization.Serializable
import kotlin.js.JsExport

@Serializable
@JsExport
data class AccountShippingAddress(
    val firstName: String,
    val lastName: String,
    val streetAddress: String? = null,
    val additionalAddress: String? = null,
    val city: String? = null,
    val state: String? = null,
    val postalCode: String? = null,
    val phone: String? = null,
)